import { Box, Text } from '@doist/marketist';
import css from './index.module.css';
function IconCard({
  title,
  href,
  image
}: {
  title: string;
  href: string;
  image: JSX.Element;
}) {
  return <Box tag="a" href={href} className={css.iconCard} data-sentry-element="Box" data-sentry-component="IconCard" data-sentry-source-file="index.tsx">
            {image}
            <Text size="minor-base" weight="medium" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                {title}
            </Text>
        </Box>;
}
export { IconCard };